import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function CurrentContractType() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  const [contractTypes, setContractTypes] = useState([]);

  useEffect(() => {
    CommonService.getContractType().then((data) => setContractTypes(data));
  }, []);
  
  return (
    <fieldset>
      <legend>{t("Current Contract Type")}</legend>
      <select
        className="form-select"
        onChange={onChange}
        value={searchObject.currentContractTypeId || ""}
        name="currentContractTypeId"
      >
        <option value=""></option>
        {contractTypes.map((contract) => (
          <option key={contract.id} value={contract.id}>
            {t(contract.description)}
          </option>
        ))}
      </select>
    </fieldset>
  );
}
